/**
 * A helper function that helps sort an array of object based on a given property.
 * The property that's passed in should be an int or a string representation of an int.
 * @param {string} property name of the property that's going to be used for sorting. This can be prefixed with - (e.g. -order) to return a different sort direction
 * @returns function that will return the sort value
 */
function dynamicSort(property) {
   var sortOrder = 1;
   if (property[0] === "-") {
      sortOrder = -1;
      property = property.substr(1);
   }
   return function (a, b) {
      if (!isNaN(a[property]) && !isNaN(b[property])) {
         var result = (parseInt(a[property]) < parseInt(b[property])) ? -1 : (parseInt(a[property]) > parseInt(b[property])) ? 1 : 0;
      } else {
         var result = (a[property] < b[property]) ? -1 : (a[property] > b[property]) ? 1 : 0;
      }
      return result * sortOrder;
   }
}

export { dynamicSort }
